export const BREAKPOINT_TABLET = 700;
export const BREAKPOINT_SMALL_DESKTOP = 1024;
export const BREAKPOINT_DESKTOP = 1366;